import { render, staticRenderFns } from "./PosReceivableDetail.vue?vue&type=template&id=2166bab7"
import script from "./PosReceivableDetail.vue?vue&type=script&lang=js"
export * from "./PosReceivableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports